gsap.registerPlugin(ScrollTrigger);
class CardAnimation {
    constructor() {
        this.cardTriggers = [];
        this.initAnimations();
        this.bindEvents();
    }

    initAnimations() {
        const elements = document.querySelectorAll("[data-card-animate]");
        if (elements.length === 0) return;
        this.killCardTriggers();
        gsap.set("[data-card-animate]", { 
            opacity: 0, 
            y: 75, 
            scale: 0.9 
        });
        const scrollTrigger = ScrollTrigger.batch("[data-card-animate]", {
            onEnter: (batch) => {
                gsap.to(batch, { 
                    opacity: 1, 
                    y: 0, 
                    scale: 1, 
                    stagger: 0.1,
                    duration: 0.6,
                    ease: "power2.out"
                });
            },
            once: true,
            start: "top 85%"
        });

        if (scrollTrigger) {
            this.cardTriggers.push(scrollTrigger);
        }
    }

    bindEvents() {
        document.addEventListener('shopify:section:load', () => {
            setTimeout(() => this.refreshAnimations(), 100);
        });
        
        document.addEventListener('shopify:section:select', () => {
            setTimeout(() => this.refreshAnimations(), 100);
        });
    }

    refreshAnimations() {
        this.killCardTriggers();
        this.initAnimations();
        ScrollTrigger.refresh();
    }

    killCardTriggers() {
        this.cardTriggers.forEach(trigger => {
            if (trigger && typeof trigger.kill === 'function') {
                trigger.kill();
            }
        });
        this.cardTriggers = [];
    }
}

class ScrollAnimation {
    constructor() {
        this.scrollTriggers = [];
        this.init();
    }

    init() {
        const animationSections = document.querySelectorAll("[data-saos]");
        if (animationSections.length === 0) return;

        animationSections.forEach((element) => {
            const animationType = element.getAttribute("data-saos");
            
            if (element.classList.contains("is-animated-gsap")) return;

            this.setInitialState(element, animationType);

            const scrollTrigger = ScrollTrigger.create({
                trigger: element,
                start: "top 85%",
                markers: false,
                once: true,
                onEnter: () => {
                    this.animateElement(element, animationType);
                    element.classList.add("is-animated-gsap");
                }
            });

            this.scrollTriggers.push(scrollTrigger);
        });
    }

    setInitialState(element, animationType) {
        switch (animationType) {
            case "fade-in":
                gsap.set(element, { opacity: 0 });
                break;
            case "slide-up":
                gsap.set(element, { opacity: 0, y: 50 });
                break;
            case "slide-down":
                gsap.set(element, { opacity: 0, y: -50 });
                break;
            case "slide-left":
                gsap.set(element, { opacity: 0, x: 50 });
                break;
            case "slide-right":
                gsap.set(element, { opacity: 0, x: -50 });
                break;
            case "scale-in":
                gsap.set(element, { opacity: 0, scale: 0.8 });
                break;
            case "scale-up":
                gsap.set(element, { opacity: 0, scale: 1.2 });
                break;
            case "rotate-in":
                gsap.set(element, { opacity: 0, rotation: 10 });
                break;
            case "flip-x":
                gsap.set(element, { opacity: 0, rotationX: 90 });
                break;
            case "flip-y":
                gsap.set(element, { opacity: 0, rotationY: 90 });
                break;
            default:
                gsap.set(element, { opacity: 0 });
        }
    }

    animateElement(element, animationType) {
        const duration = parseFloat(element.dataset.duration) || 0.8;
        const delay = parseFloat(element.dataset.delay) || 0;

        switch (animationType) {
            case "fade-in":
                gsap.to(element, { 
                    opacity: 1, 
                    duration: duration,
                    delay: delay 
                });
                break;
            case "slide-up":
                gsap.to(element, { 
                    opacity: 1, 
                    y: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "slide-down":
                gsap.to(element, { 
                    opacity: 1, 
                    y: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "slide-left":
                gsap.to(element, { 
                    opacity: 1, 
                    x: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "slide-right":
                gsap.to(element, { 
                    opacity: 1, 
                    x: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "scale-in":
                gsap.to(element, { 
                    opacity: 1, 
                    scale: 1, 
                    duration: duration,
                    delay: delay,
                    ease: "back.out(1.7)" 
                });
                break;
            case "scale-up":
                gsap.to(element, { 
                    opacity: 1, 
                    scale: 1, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "rotate-in":
                gsap.to(element, { 
                    opacity: 1, 
                    rotation: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "flip-x":
                gsap.to(element, { 
                    opacity: 1, 
                    rotationX: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            case "flip-y":
                gsap.to(element, { 
                    opacity: 1, 
                    rotationY: 0, 
                    duration: duration,
                    delay: delay,
                    ease: "power2.out" 
                });
                break;
            default:
                gsap.to(element, { 
                    opacity: 1, 
                    duration: duration,
                    delay: delay 
                });
        }
    }

    kill() {
        this.scrollTriggers.forEach(trigger => {
            if (trigger && typeof trigger.kill === 'function') {
                trigger.kill();
            }
        });
        this.scrollTriggers = [];
    }

    reinit() {
        this.kill();
        document.querySelectorAll("[data-saos]").forEach(el => {
            el.classList.remove("is-animated-gsap");
        });
        this.init();
    }
}

let cardAnimation;
let scrollAnimation;

function initAnimations() {
    if (typeof CardAnimation !== 'undefined') {
        cardAnimation = new CardAnimation();
    }
    
    if (typeof ScrollAnimation !== 'undefined') {
        scrollAnimation = new ScrollAnimation();
    }

    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 100);
}

if (typeof gsap !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAnimations);
    } else {
        initAnimations();
    }
}

let resizeTimer;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
        ScrollTrigger.refresh();
    }, 250);
});

document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
        if (scrollAnimation) {
            scrollAnimation.reinit();
        }
        if (cardAnimation) {
            cardAnimation.refreshAnimations();
        }
        ScrollTrigger.refresh();
    }, 100);
});

document.addEventListener('shopify:section:select', () => {
    setTimeout(() => {
        if (scrollAnimation) {
            scrollAnimation.reinit();
        }
        if (cardAnimation) {
            cardAnimation.refreshAnimations();
        }
        ScrollTrigger.refresh();
    }, 100);
});

document.addEventListener('shopify:section:unload', () => {
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 100);
});

window.initSectionAnimations = function(sectionSelector) {
  const section = typeof sectionSelector === 'string' 
    ? document.querySelector(sectionSelector) 
    : sectionSelector;
  
  if (!section) {
    return;
  }
  
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {

    return;
  }
  
  const saosElements = section.querySelectorAll('[data-saos]:not(.is-animated-gsap)');
  
  saosElements.forEach(element => {
    const animationType = element.getAttribute('data-saos');
    const duration = parseFloat(element.dataset.duration) || 0.8;
    const delay = parseFloat(element.dataset.delay) || 0;

    switch (animationType) {
      case "fade-in":
        gsap.set(element, { opacity: 0 });
        break;
      case "slide-up":
        gsap.set(element, { opacity: 0, y: 40 });
        break;
      case "slide-down":
        gsap.set(element, { opacity: 0, y: -40 });
        break;
      case "slide-left":
        gsap.set(element, { opacity: 0, x: 40 });
        break;
      case "slide-right":
        gsap.set(element, { opacity: 0, x: -40 });
        break;
      case "scale-in":
        gsap.set(element, { opacity: 0, scale: 0.8 });
        break;
      default:
        gsap.set(element, { opacity: 0, y: 40 });
    }
    
    ScrollTrigger.create({
      trigger: element,
      start: "top 85%",
      once: true,
      markers: false,
      onEnter: () => {
        switch (animationType) {
          case "fade-in":
            gsap.to(element, { opacity: 1, duration, delay });
            break;
          case "slide-up":
            gsap.to(element, { opacity: 1, y: 0, duration, delay, ease: "power2.out" });
            break;
          case "slide-down":
            gsap.to(element, { opacity: 1, y: 0, duration, delay, ease: "power2.out" });
            break;
          case "slide-left":
            gsap.to(element, { opacity: 1, x: 0, duration, delay, ease: "power2.out" });
            break;
          case "slide-right":
            gsap.to(element, { opacity: 1, x: 0, duration, delay, ease: "power2.out" });
            break;
          case "scale-in":
            gsap.to(element, { opacity: 1, scale: 1, duration, delay, ease: "back.out(1.7)" });
            break;
          default:
            gsap.to(element, { opacity: 1, y: 0, duration, delay, ease: "power2.out" });
        }
        element.classList.add('is-animated-gsap');
      }
    });
  });
  
  const cardElements = section.querySelectorAll('[data-card-animate]:not(.is-animated-gsap)');
  
  if (cardElements.length > 0) {
    gsap.set(cardElements, { 
      opacity: 0, 
      y: 75, 
      scale: 0.9 
    });

    ScrollTrigger.batch(cardElements, {
      onEnter: (batch) => {
        gsap.to(batch, { 
          opacity: 1, 
          y: 0, 
          scale: 1, 
          stagger: 0.1,
          duration: 0.6,
          ease: "power2.out",
          onComplete: () => {
            batch.forEach(card => card.classList.add('is-animated-gsap'));
          }
        });
      },
      once: true,
      start: "top 85%"
    });
  }
  
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);
};

window.refreshAllAnimations = function() {
  if (window.cardAnimation && typeof window.cardAnimation.refreshAnimations === 'function') {
    window.cardAnimation.refreshAnimations();
  }
  
  if (window.scrollAnimation && typeof window.scrollAnimation.reinit === 'function') {
    window.scrollAnimation.reinit();
  }
  
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  }
};

document.addEventListener('shopify:section:load', (event) => {
  setTimeout(() => {
    if (event.target) {
      window.initSectionAnimations(event.target);
    } else {
      window.refreshAllAnimations();
    }
  }, 100);
});

document.addEventListener('shopify:section:select', (event) => {
  setTimeout(() => {
    if (event.target) {
      window.initSectionAnimations(event.target);
    }
  }, 100);
});

window._gsapAnimationsReady = false;

function _exposeAnimationHelpers() {
  try {
    if (typeof cardAnimation !== 'undefined') window.cardAnimation = cardAnimation;
    if (typeof scrollAnimation !== 'undefined') window.scrollAnimation = scrollAnimation;
    window.reinitAllAnimations = function() {
      document.querySelectorAll("[data-card-animate], [data-saos]").forEach(el => {
        el.classList.remove("is-animated-gsap");
        el.style.opacity = "";
        el.style.transform = "";
        el.style.transition = "";
      });

      try {
        if (window.scrollAnimation && typeof window.scrollAnimation.reinit === 'function') {
          window.scrollAnimation.reinit();
        }
      } catch(e){ console.warn('scrollAnimation.reinit error', e); }

      try {
        if (window.cardAnimation && typeof window.cardAnimation.refreshAnimations === 'function') {
          window.cardAnimation.refreshAnimations();
        }
      } catch(e){ console.warn('cardAnimation.refreshAnimations error', e); }

      if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
        window.ScrollTrigger.refresh();
      }
    };

    window._gsapAnimationsReady = true;
  } catch (err) {
    console.warn('Unable to expose animation helpers', err);
  }
}

if (typeof cardAnimation !== 'undefined' || typeof scrollAnimation !== 'undefined') {
  _exposeAnimationHelpers();
} else {
  setTimeout(() => {
    _exposeAnimationHelpers();
  }, 150);
}
